var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`layout --${_vm.$route.name}`},[_c('Navbar'),_c('div',{staticClass:"layout__main-container"},[_c('Sidebar'),_c('div',{staticClass:"layout__main-container__body",attrs:{"id":"layout-body"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }